'use client';

import { Combobox } from '@/components/utils/combobox';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

const LaboratoryCity = ({
    data,
}: {
    data: { city: { label: string; value: string; api: string }[] };
}) => {
    const [city, setCity] = useState(''); 
    const router = useRouter();
    return (
        data && (
            <div className="flex-shrink w-full smp:!w-fit">
                <Combobox
                    placeholder="شهر"
                    onChange={(item) => {
                        if (item) {
                            setCity(String(item));
                            router.push(
                                `/centers/city/${String(item)}/type/lab`,
                            );
                        } else {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any 
                            setCity(null as any);
                        }
                    }}
                    options={data.city}
                    value={city}
                    btnClassName="!text-black !gap-6 mt-1 !rounded-2xl !bg-white"
                    reverseColoring
                />
            </div>
        )
    );
};

export default LaboratoryCity;
